
















import { Component, Vue, Prop } from 'vue-property-decorator';
//import '@vaadin/vaadin-login/vaadin-login-overlay.js';

@Component({
  components: {},
})
export default class Authentication extends Vue {
  public beforeRouteUpdate(to: any, from: any, next: any) {
    if (this.$root.$data.userState.signedIn) {
      if (from.name === 'auth') {
        next({ path: '/' });
        return;
      } else {
        next(false);
        return;
      }
    }

    next();
  }
}
